import { useInitOnce } from '@/generic/init';
import { PROVIDE_DIAGNOSTIC, provideDiagnostic } from '@/diagnostic/DiagnosticProvider.ts';
import { DiagnosticHistoryPageComponent } from '@/diagnostic/primary/DiagnosticHistoryPageComponent.tsx';

export const DiagnosticHistoryApp = () => {
  useInitOnce(PROVIDE_DIAGNOSTIC, provideDiagnostic);
  return <DiagnosticHistoryPageComponent />;
};
